

import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import Loader from '../loader/Loader';
const MaterialInspectionReportModal = ({ show, handleClose, materialId,onAccept }) => {
    const [materials, setMaterials] = useState(null);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        material_id: '',
        expected_qty: '',
        supplier_name: '',
        supplier_contact: '',
        inspection_date: '',
        visual_inspection: false,
        dimensional_check: false,
        quantity_check: false,
        packaging_condition: false,
        material_certificate: false,
        actual_quantity: '',
        quantity_rejected: '',
        decision: '',
        notes: ''
    });
    useEffect(() => {
        if (show && materialId) {
            fetchMaterial(materialId);
        }
    }, [show, materialId]);

    const fetchMaterial = async (materialId) => {
        const token = getAuthToken();
        if (!token) return;
        try {
            setLoading(true)
            const response = await axios.get(`${config.API}/supervisor/incomingmaterialacceptance/${materialId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            const mat = response?.data?.incoming_material;
            if (mat) {
                setMaterials(mat);
                setForm((prev) => ({
                    ...prev,
                    material_id: mat.id,
                    expected_qty: mat.expected_qty,
                    supplier_name: mat.supplier_name || '',
                    supplier_contact: mat.supplier_contact || '',
                    inspection_date: new Date().toISOString().split("T")[0]
                }));
            }
        } catch (err) {
            console.error("Error fetching material:", err.message);
            setMaterials(null);
            toast.error("Material record not found!");
        }finally{
            setLoading(false)
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

const handleSubmit = async (e) => {
    e.preventDefault();
    const token = getAuthToken();
    if (!token) {
        toast.error("Authentication token missing!");
        return;
    }

    try {
        const payload = {
            material_id: Number(materials?.id),
            expected_qty: Number(materials?.expected_qty),
            supplier_name: materials?.supplier_name,
            supplier_contact: form.supplier_contact,
            inspection_date: form.inspection_date,
            visual_inspection: form.visual_inspection,
            dimensional_check: form.dimensional_check,
            quantity_check: form.quantity_check,
            packaging_condition: form.packaging_condition,
            material_certificate: form.material_certificate,
            actual_quantity: Number(form.actual_quantity),
            quantity_rejected: Number(form.quantity_rejected),
            decision: form.decision,
            notes: form.notes
        };

        const response = await axios.post(
            `${config.API}/supervisor/incomingmaterialacceptance/${materialId}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        const resData = response.data;

        if (resData.success) {
            toast.success(resData.message || "Inspection report submitted!");
            // ✅ Reset form
            setForm({
                material_id: '',
                expected_qty: '',
                supplier_name: '',
                supplier_contact: '',
                inspection_date: '',
                visual_inspection: false,
                dimensional_check: false,
                quantity_check: false,
                packaging_condition: false,
                material_certificate: false,
                actual_quantity: '',
                quantity_rejected: '',
                decision: '',
                notes: ''
            });
            handleClose();
            onAccept();
        } else {
            // ✅ Show backend message even when success = false
            toast.error(resData.message || "Failed to submit inspection report!");
        }

    } catch (err) {
        console.error("Error submitting inspection report:", err);

        if (err.response && err.response.status === 422) {
            const errors = err.response.data?.errors;
            if (errors) {
                Object.values(errors).forEach((msgArray) => {
                    msgArray.forEach(msg => toast.error(msg));
                });
            } else {
                toast.error(err.response.data?.message || "Validation error!");
            }
        } else {
            // ✅ Show backend message if available even in catch
            const backendMsg = err.response?.data?.message;
            toast.error(backendMsg || "Failed to submit inspection report!");
        }
    }
};

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className='font_family'>
            <Modal.Header closeButton className='border-0 p-4'>
                <strong className='fs-4'>Material Inspection Report</strong>
            </Modal.Header>
           {
            loading ?(
                <Loader/>
            ):(
                 <Modal.Body className='p-4'>
                {/* Material Info */}
                <Card className="mb-3">
                    <Card.Body>
                        <Row>
                            <Col xs={6}><strong>ID:</strong> {materials?.material_master?.material_code}</Col>
                            <Col xs={6}><strong>Material:</strong> {materials?.material_master?.material_name}</Col>
                        </Row>
                        <Row className="mt-2">
                            <Col xs={6}><strong>Expected Qty:</strong> {materials?.expected_qty}</Col>
                            <Col xs={6}><strong>Supplier:</strong> {materials?.supplier_name || 'N/A'}</Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Checklist */}
                <Card className="mb-3">
                    <Card.Body>
                        <Form.Check type="checkbox" label="Visual Inspection" name="visual_inspection" checked={form.visual_inspection} onChange={handleChange} />
                        <Form.Check type="checkbox" label="Dimensional Check" name="dimensional_check" checked={form.dimensional_check} onChange={handleChange} />
                        <Form.Check type="checkbox" label="Quantity Check" name="quantity_check" checked={form.quantity_check} onChange={handleChange} />
                        <Form.Check type="checkbox" label="Packaging Condition" name="packaging_condition" checked={form.packaging_condition} onChange={handleChange} />
                        <Form.Check type="checkbox" label="Material Certificate" name="material_certificate" checked={form.material_certificate} onChange={handleChange} />
                    </Card.Body>
                </Card>

                {/* Actual & Rejected Qty */}
                <Form.Group as={Row} className="align-items-center mb-3 ms-3 g-4">
                    <Form.Label column xs={6} md={2}>
                        Actual Quantity
                    </Form.Label>
                    <Col xs={4} md={3}>
                        <Form.Control
                            type="text"
                            name="actual_quantity"
                            value={form.actual_quantity}
                            onChange={handleChange}
                        />
                    </Col>
                    <Col xs={2} md={1} className="ps-0">pcs</Col>

                    <Form.Label column xs={6} md={2} className="text-md-end">
                        Quantity Rejected
                    </Form.Label>
                    <Col xs={4} md={3}>
                        <Form.Control
                            type="text"
                            name="quantity_rejected"
                            value={form.quantity_rejected}
                            onChange={handleChange}
                        />
                    </Col>
                    <Col xs={2} md={1} className="ps-0">pcs</Col>
                </Form.Group>

                {/* Decision */}
                <Form.Group as={Row} className="mb-3 ms-5">
                    <Form.Label column md={2}>Decision</Form.Label>
                    <Col md={10}>
                        <Form.Select
                            name="decision"
                            value={form.decision}
                            onChange={handleChange}
                        >
                            <option value="">Select decision</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                            <option value="Hold">Hold</option>
                        </Form.Select>
                    </Col>
                </Form.Group>

                {/* Notes */}
                <Form.Group as={Row} className="mb-3 ms-5">
                    <Form.Label column md={2}>Notes</Form.Label>
                    <Col md={10}>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="notes"
                            value={form.notes}
                            onChange={handleChange}
                            placeholder="Additional notes or observations"
                        />
                    </Col>
                </Form.Group>
            </Modal.Body>
            )
           }
            <Modal.Footer className='border-0'>
                <Button variant="outline-secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="dark" onClick={handleSubmit}>
                    Accept Material
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MaterialInspectionReportModal;
